import { postRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function newIncotermRequest(incoterm) {
	let url = incoterms.getPath();
	let response = await postRequest(url, {}, incoterm);
	return response;
}